import { ComponentPropsWithoutRef, MouseEvent, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { Box } from '../../../common/ui/Box';
import { get } from '../../../common/ui/get';

interface DefaultCellProps extends ComponentPropsWithoutRef<'td'> {
    numeric?: boolean;
    emphasis?: 'default' | 'attention';
    interactive?: boolean;
    children?: ReactNode;
    hideOnLoading?: boolean;
    isLoading?: boolean;
    truncate?: boolean;
}

const StyledDefaultCell = styled.td.attrs((props) => ({
    emphasis: 'default',
    hideOnLoading: false,
    truncate: false,
    ...props,
}))<DefaultCellProps>`
    border-top: 1px solid ${get('colors.background.inset')};
    color: ${(props) => (props.emphasis === 'attention' ? get('colors.attention.foreground') : 'inherit')};

    text-align: ${(props) => (props.numeric ? 'right' : 'left')};

    ${(props) => (props.truncate ? 'max-width: 0' : '')};

    /* Padding for text-only cells */
    &:not(:has(*)) {
        padding-left: 16px;
        padding-right: 16px;
    }

    /* Padding for the first child element */
    &:has(*) > *:first-child {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const DefaultCell = (props: DefaultCellProps) => {
    const onClick = (event: MouseEvent) => {
        if (props.interactive) {
            event.stopPropagation();
        }
    };

    return (
        <StyledDefaultCell {...props} onClick={onClick}>
            {props.isLoading && !props.hideOnLoading ? (
                <Box
                    height={40}
                    display="flex"
                    alignItems="center"
                    justifyContent={props.numeric ? 'flex-end' : 'flex-start'}
                >
                    <Box width="70%">
                        <Skeleton height={16} />
                    </Box>
                </Box>
            ) : null}

            {!props.isLoading ? props.children : null}
        </StyledDefaultCell>
    );
};
